module.exports = __webpack_public_path__ + "img/ic_custprint.c897cff0.png";